export default {
    title: "Kevi | Status de Pedido",
    page_title: "Status de Pedido",
    approved: "Aprovado",
    pending: "Pendente",
    cancelled: "Cancelado",
    save: "Salvar",
    success_message: "Status atualizados",
    external_label_column: "Status externo",
    kevi_status_column: "Status Kevi",
    repurchase_reference_column: "Referência de recompra",
    repurchase_reference_help:
        "A referência de recompra define a partir de quando o tempo de recompra dos produtos começa a contar. Sem nenhum status marcado, a contagem começa na data de criação do pedido. Ao marcar um ou mais status, um pedido aprovado só passa a contar quando atingir o primeiro status marcado (por exemplo, \"entregue\"), usando o momento em que a Kevi detectou essa mudança. Alterar essa seleção recalcula as previsões na próxima execução noturna.",
};
